import request from '@/utils/request'
import { getCommunityId } from '@/api/community/communityApi'

// 获取房产留资列表
export function listBuildingForms(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/building.listBuildingForms',
      method: 'get',
      params: {
        ...params,
        communityId: getCommunityId()
      }
    }).then(response => {
      const res = response.data
      resolve({
        data: res.data,
        total: res.total
      })
    }).catch(error => {
      reject(error)
    })
  })
}

// 获取房产留资详情
export function getBuildingFormById(id) {
  return new Promise((resolve, reject) => {
    request({
      url: `/building.listBuildingForms`,
      method: 'get',
      params: {
        communityId: getCommunityId(),
        id:id
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 创建房产留资
export function createBuildingForm(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/building.saveBuildingForm',
      method: 'post',
      data: {
        ...data,
        communityId: getCommunityId()
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// // 更新房产留资
// export function updateBuildingForm(data) {
//   return new Promise((resolve, reject) => {
//     request({
//       url: '/oa/buildingForm/update',
//       method: 'post',
//       data: {
//         ...data,
//         communityId: getCommunityId()
//       }
//     }).then(response => {
//       const res = response.data
//       resolve(res)
//     }).catch(error => {
//       reject(error)
//     })
//   })
// }
//
// // 删除房产留资
// export function deleteBuildingForm(id) {
//   return new Promise((resolve, reject) => {
//     request({
//       url: `/oa/buildingForm/${id}`,
//       method: 'delete',
//       data: {
//         communityId: getCommunityId()
//       }
//     }).then(response => {
//       const res = response.data
//       resolve(res)
//     }).catch(error => {
//       reject(error)
//     })
//   })
// }

